import React from 'react'
import flogo from './flogo.jpg'


function Navbar() {
  return (
    <div className='container my-3'>
      <div className='row'>
        <div className='col-md-12'>

       
      <nav className="navbar navbar-expand-lg ">
  <div className="container-fluid">
  <img src={flogo} alt=''/>
    <a  className="navbar-brand" href="/">FUNDGUARD</a>
    
    
    <button className="navbar-toggler navbar-light" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
    </button>
    <div className="collapse navbar-collapse" id="navbarSupportedContent">
      <ul className="navbar-nav me-auto mb-2 mb-lg-0">
        <li className="nav-item">
          <a className="nav-link active" aria-current="page" href="/">Home</a>
        </li>
        <li className="nav-item">
          <a className="nav-link" href="/About">About</a>
        </li>
        <li className="nav-item">
          <a className="nav-link" href="/Services">Services</a>
        </li>
        <li className="nav-item">
          <a className="nav-link" href="/Licinfo">Licinfo</a>
        </li>
        <li className="nav-item">
          <a className="nav-link" href="/Contact">Contact</a>
        </li>

       
       
      </ul>
     
    </div>
  </div>
</nav>
</div>

</div>
    </div>
  )
}

export default Navbar
